module.exports = __webpack_public_path__ + "img/Frame_47.6f274013.png";